import { checkGate, getExperiment, getLayer } from '@eventbrite/statsig';
import {
    ConfirmationPageReferralExperimentVariant,
    EnhanceLogionOptionExperimentVariant,
    ENHANCE_LOGIN_OPTION_IN_CHECKOUT_EXPERIMENT,
    ExpressOnlyCheckoutExperimentVariant,
    ExpressPaymentMethods,
    EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT,
    FOLLOW_CARD_PLACEMENT_EXPERIMENT,
    GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT,
    PostCheckoutMandatoryQuestionsInAppVariant,
    POST_CHECKOUT_MANDATORY_QUESTIONS_IN_ANDROID_APP,
    StripeElementsAustraliaExperimentVariant,
    STRIPE_ELEMENTS_AUSTRALIA_EXPERIMENT,
    TimedEntryPhase2CheckoutExperimentVariant,
    TIMED_ENTRY_PHASE_2_CHECKOUT_EXPERIMENT,
} from '../constants/statsig';

export const checkEnablePayPalLineItemsFeatureGate = () =>
    checkGate('checkout_enable_paypal_line_items');

export const getFollowCardPlacementExperiment = () =>
    getLayer(
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.layer,
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.param,
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.defaultValue,
    );

export const getGooglePayOnTicketSelectionExperimentValue =
    (): ExpressPaymentMethods =>
        getLayer(
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
        );

export const getReferralInOrderConfirmationExperiment =
    (): ConfirmationPageReferralExperimentVariant =>
        getExperiment(
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.experiment,
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.param,
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.defaultValue,
        );

export const getExpressOnlyCheckoutExperiment =
    (): ExpressOnlyCheckoutExperimentVariant =>
        getLayer(
            EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT.layer,
            EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT.param,
            EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT.defaultValue,
        );

export const getEnhanceLoginOptionExperimentValue =
    () => (): EnhanceLogionOptionExperimentVariant =>
        getExperiment(
            ENHANCE_LOGIN_OPTION_IN_CHECKOUT_EXPERIMENT.experiment,
            ENHANCE_LOGIN_OPTION_IN_CHECKOUT_EXPERIMENT.param,
            ENHANCE_LOGIN_OPTION_IN_CHECKOUT_EXPERIMENT.defaultValue,
        );

export const getPostCheckoutMandatoryQuestionsInAndroidApp =
    (): PostCheckoutMandatoryQuestionsInAppVariant =>
        getExperiment(
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_ANDROID_APP.experiment,
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_ANDROID_APP.param,
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_ANDROID_APP.defaultValue,
        );

export const getStripeElementsAustraliaExperimentValue =
    (): StripeElementsAustraliaExperimentVariant =>
        getLayer(
            STRIPE_ELEMENTS_AUSTRALIA_EXPERIMENT.layer,
            STRIPE_ELEMENTS_AUSTRALIA_EXPERIMENT.param,
            STRIPE_ELEMENTS_AUSTRALIA_EXPERIMENT.defaultValue,
        );

export const getTimedEntryPhase2CheckoutExperimentValue =
    (): TimedEntryPhase2CheckoutExperimentVariant =>
        getExperiment(
            TIMED_ENTRY_PHASE_2_CHECKOUT_EXPERIMENT.experiment,
            TIMED_ENTRY_PHASE_2_CHECKOUT_EXPERIMENT.param,
            TIMED_ENTRY_PHASE_2_CHECKOUT_EXPERIMENT.defaultValue,
        );
